import { IActionIconButton } from '../../../interfaces/actions'
import { SideItemProps } from '../../../interfaces/sideContent'
import { SideIconButton, SideItemWrapper, SideTags } from './ItemCard.styles'
import { TagItemProps } from '../Tags'
import Icon from '../Icon'

const SideItem = ({
  type,
  props,
  data,
  area = 'top',
  side = 'start',
  disableWhenReadOnly = false,
  hideWhenReadOnly = false,
  ...sideProps
}: SideItemProps) => {
  const hiddenClass =
    hideWhenReadOnly && (data?.readOnly || data?.isHidden) ? 'hidden' : ''

  if (type === 'iconButton') {
    const { actions, ...iconButtonProps }: IActionIconButton = { ...props }
    const disabled = disableWhenReadOnly && (data?.readOnly || data?.isHidden)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = (event: any) => {
      event.preventDefault()
      event.stopPropagation()
      if (actions) {
        actions({ data })
      }
    }
    return (
      <SideItemWrapper
        className={`SideContentItem SideContentButton area-${area} side-${side} ${hiddenClass}`}
        type={type}
        {...sideProps}>
        <SideIconButton
          {...iconButtonProps}
          disabled={disabled}
          onClick={(event) => handleClick(event)}
        />
      </SideItemWrapper>
    )
  }

  if (type === 'tag') {
    const tag = [props as unknown as TagItemProps]
    return (
      <SideItemWrapper
        className={`SideContentItem SideContentTags area-${area} side-${side}`}
        type={type}
        {...sideProps}>
        <SideTags items={tag} />
      </SideItemWrapper>
    )
  }

  if (type === 'icon') {
    return (
      <SideItemWrapper
        className={`SideContentItem SideContentTags area-${area} side-${side}`}
        type={type}
        {...sideProps}>
        <Icon {...props} />
      </SideItemWrapper>
    )
  }

  return null
}

export default SideItem
